import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import imgFrame427321791 from "../assets/images/801c36195628ec9551d571118f7e538a22e2ed29.png";

function HeaderLinks({ className }: { className?: string }) {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (top: number) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        window.scrollTo({
          top: top,
          behavior: "smooth"
        });
      }, 100);
    } else {
      window.scrollTo({
        top: top,
        behavior: "smooth"
      });
    }
  };

  return (
    <div className={"flex flex-col lg:flex-row items-center gap-6 lg:gap-[74px] " + (className || "")}>
      <p 
        onClick={() => scrollToSection(0)} 
        className="font-['Epilogue:SemiBold',sans-serif] font-semibold text-[#3056d3] cursor-pointer hover:opacity-80 transition-opacity"
      >
        Home
      </p>
      <p 
        onClick={() => scrollToSection(2818)} 
        className="font-['Epilogue:Medium',sans-serif] font-medium text-[#3d3d3d] cursor-pointer hover:text-[#3056d3] hover:opacity-80 transition-opacity"
      >
        About us
      </p>
      <p 
        onClick={() => scrollToSection(1024)} 
        className="font-['Epilogue:Medium',sans-serif] font-medium text-[#3d3d3d] cursor-pointer hover:text-[#3056d3] hover:opacity-80 transition-opacity"
      >
        Services
      </p>
      <p 
        onClick={() => scrollToSection(9165)} 
        className="font-['Epilogue:Medium',sans-serif] font-medium text-[#3d3d3d] cursor-pointer hover:text-[#3056d3] hover:opacity-80 transition-opacity"
      >
        Contact Us
      </p>
    </div>
  );
}

function HeaderBookButton() {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToContact = () => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        window.scrollTo({
          top: 9165,
          behavior: "smooth"
        });
      }, 100);
    } else {
      window.scrollTo({
        top: 9165,
        behavior: "smooth"
      });
    }
  };

  return (
    <button 
      onClick={scrollToContact}
      className="bg-[#107cf7] px-6 py-3 rounded-full text-white font-['Inter:Medium',sans-serif] font-medium hover:bg-blue-600 transition-colors shadow-md text-sm lg:text-base whitespace-nowrap active:scale-95 transition-transform"
    >
      BOOK NOW
    </button>
  );
}

export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (top: number) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        window.scrollTo({
          top: top,
          behavior: "smooth"
        });
      }, 100);
    } else {
      window.scrollTo({
        top: top,
        behavior: "smooth"
      });
    }
  };

  return (
    <header className="w-full max-w-[1440px] mx-auto flex items-center justify-between px-6 lg:px-20 py-4 absolute top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md lg:bg-transparent lg:backdrop-blur-none border-b border-black/5 lg:border-none">
      {/* Logo */}
      <div className="w-[180px] h-[50px] lg:w-[232px] lg:h-[80px] relative cursor-pointer" onClick={() => scrollToSection(0)}>
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <img alt="Fixezy Logo" className="absolute h-[428.45%] left-[-24.57%] max-w-none top-[-159%] w-[147.98%]" src={imgFrame427321791} />
        </div>
      </div>

      {/* Links - Hidden on mobile/tablet */}
      <div className="hidden lg:flex bg-[#f7f7fd] px-8 py-3 rounded-full shadow-inner">
        <HeaderLinks />
      </div>

      {/* Button CTA */}
      <div>
        <HeaderBookButton />
      </div>
    </header>
  );
}